// module.exports.baseUrl = "http://198.71.61.220:3300/api/v1";
module.exports.baseUrl = `${window.location.origin}/api/v1`;
// module.exports.baseUrl = `http://localhost:3300/api/v1`;
// module.exports.baseUrl = "https://0133-202-43-120-43.ngrok-free.app/api/v1";
module.exports.CAPTCHA_SITE_KEY="6LeruwAqAAAAAHVqqmZ8if2Mhqy3ljrQgPH7kwJo";
